import { IntlShape } from 'react-intl';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { CommonMessages } from '../../../common';

type UseCreateUserForm = (intl: IntlShape) => UseFormReturn;

export const useCreateUserForm: UseCreateUserForm = (intl) => {
  const userValidationSchema = yup.object().shape({
    name: yup.string(),
    email: yup
      .string()
      .required(intl.formatMessage(CommonMessages.emailRequiredError))
      .min(2)
      .matches(
        /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        'Invalid email is entered',
      ),
    scope: yup.string(),
    type: yup
      .string()
      .required()
      .equals(['Standalone'], 'Only standalone users can be created manually'),
    autoSendPass: yup.boolean().default(false),
    password: yup.string().when('autoSendPass', {
      is: false,
      then: (rule) =>
        rule
          .min(8, 'Password must be at least 8 characters long')
          .required('Password is required')
          .matches(
            /\d/,
            'Password must be at least 8 characters long including 1 uppercase letter, 1 special character and 1 number',
          )
          .matches(
            /[A-Z]/,
            'Password must be at least 8 characters long including 1 uppercase letter, 1 special character and 1 number',
          )
          .matches(
            /[a-z]{2}/,
            'Password must be at least 8 characters long including 1 uppercase letter, 1 special character and 1 number',
          )
          .matches(
            /[$&+,:;=?@#|'<>.^*()%!/-]/,
            'Password must be at least 8 characters long including 1 uppercase letter, 1 special character and 1 number',
          ),
    }),
    confirmPassword: yup.string().when('autoSendPass', {
      is: false,
      then: (rule) => rule.oneOf([yup.ref('password')], 'Passwords must match').required(),
    }),
  });

  return useForm({
    resolver: yupResolver(userValidationSchema),
    mode: 'onChange',
  });
};
